import { parseLocalDateString } from './dateUtils';

export const PROGRESS_REPORT_FEES = {
  regular: { client: 840, therapist: 500 },
  rushed: { client: 1260, therapist: 875 },
};

export const PROGRESS_REPORT_LEAD_DAYS = 14;

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

function toLocalMidnight(value) {
  if (!value) {
    return null;
  }

  if (typeof value === 'string' && DATE_ONLY_PATTERN.test(value)) {
    return parseLocalDateString(value);
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  date.setHours(0, 0, 0, 0);
  return date;
}

export const PROGRESS_REPORT_STATUSES = {
  PENDING_PAYMENT: 'pending_payment',
  PAID: 'paid',
  THERAPIST_NOTIFIED: 'therapist_notified',
  SUBMITTED: 'submitted',
};

export const PROGRESS_REPORT_STATUS_LABELS = {
  pending_payment: 'Pending Payment',
  paid: 'Paid',
  therapist_notified: 'Therapist Notified',
  submitted: 'Submitted',
};

/**
 * Returns true when due date is less than 14 days after the reference date.
 * @param {string|Date} dueDate
 * @param {string|Date} referenceDate - typically paid_at or today
 */
export function isRushedProgressReport(dueDate, referenceDate) {
  const due = toLocalMidnight(dueDate);
  const ref = toLocalMidnight(referenceDate);

  if (!due || !ref) {
    return false;
  }

  const diffMs = due.getTime() - ref.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);

  return diffDays < PROGRESS_REPORT_LEAD_DAYS;
}

/**
 * Derives rushed/regular from the request's current dates and status.
 * Pending rows use requested_at → due_date; paid rows use paid_at → due_date.
 */
export function getProgressReportRushedStatus(request) {
  if (!request?.due_date) {
    return false;
  }

  if (request.status === PROGRESS_REPORT_STATUSES.PENDING_PAYMENT) {
    return isRushedProgressReport(request.due_date, request.requested_at);
  }

  if (request.paid_at) {
    return isRushedProgressReport(request.due_date, request.paid_at);
  }

  return Boolean(request.is_rushed);
}

export function getProgressReportFees(isRushed) {
  return isRushed ? PROGRESS_REPORT_FEES.rushed : PROGRESS_REPORT_FEES.regular;
}

export function projectRushedFromDueDate(dueDate, referenceDate = new Date()) {
  return isRushedProgressReport(dueDate, referenceDate);
}
